import React from 'react';
import { Helmet } from 'react-helmet';

const AppHelmet = ({ children }) => {
  const siteName = 'SayCheeze Cakes';
  const baseUrl = 'https://www.saycheezecakes.com';
  const defaultTitle = `${siteName} | Custom Cakes & Desserts in Bangalore`;
  const defaultDescription =
    'SayCheeze Cakes crafts premium custom cakes, desserts, and bakes in Bangalore using high-quality ingredients. Celebrate birthdays, anniversaries, and special moments with made-to-order cakes.';
  const defaultImage = `${baseUrl}/assets/images/logo.png`;

  return (
    <>
      <Helmet defaultTitle={defaultTitle} titleTemplate={`%s | ${siteName}`}>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <title>{defaultTitle}</title>
        <meta name='description' content={defaultDescription} />
        <meta
          name='keywords'
          content='SayCheeze Cakes, custom cakes Bangalore, designer cakes, birthday cakes, anniversary cakes, desserts, bakery, online cake order Bangalore'
        />

        {/* Open Graph / Facebook */}
        <meta property='og:type' content='website' />
        <meta property='og:title' content={defaultTitle} />
        <meta property='og:description' content={defaultDescription} />
        <meta property='og:url' content={baseUrl} />
        <meta property='og:site_name' content={siteName} />
        <meta property='og:image' content={defaultImage} />

        {/* Twitter */}
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content={defaultTitle} />
        <meta name='twitter:description' content={defaultDescription} />
        <meta name='twitter:image' content={defaultImage} />

        <link rel='canonical' href={baseUrl} />
      </Helmet>
      {children}
    </>
  );
};

export default AppHelmet;
